import {Button} from 'antd';
import PropTypes from 'prop-types';
import {useEffect, useRef, useState} from 'react';

const ImageSection = ({data}) => {
  const [bigImage, setBigImage] = useState(null);

  const thumbnailRef = useRef(null);

  useEffect(() => {
    if (Array.isArray(data?.imageUrl) && data.imageUrl.length > 0) {
      setBigImage(data.imageUrl[0]);
    }
  }, [data]);

  const handleImageClick = image => {
    setBigImage(image);
  };

  useEffect(() => {
    if (Array.isArray(data?.imageUrl) && data.imageUrl.length > 0) {
      setBigImage(data.imageUrl[0]);
    }

    let scrollInterval;
    if (data?.imageUrl?.length > 4 && thumbnailRef.current) {
      const container = thumbnailRef.current;
      let scrollAmount = 0;
      const scrollStep = 50;
      if (container.scrollHeight > container.clientHeight) {
        scrollInterval = setInterval(() => {
          container.scrollTop += scrollStep;
          scrollAmount += scrollStep;

          if (scrollAmount >= container.scrollHeight - container.clientHeight) {
            container.scrollTop = 0;
            scrollAmount = 0;
          }
        }, 2000);
      }
    }
    return () => clearInterval(scrollInterval);
  }, [data]);

  return (
    <div className={'flex flex-col items-start justify-center w-full'}>
      <div className={'flex flex-col lg:flex-row gap-4 w-full'}>
        <div ref={thumbnailRef}
          className={'lg:block hidden sm:w-1/4 w-full flex sm:flex-col flex-row gap-4 overflow-x-auto sm:overflow-y-auto sm:h-96 max-w-[200px]'}>
          {Array.isArray(data.imageUrl) &&
            data.imageUrl.map((img, index) => (
              <Button
                key={index}
                onClick={() => handleImageClick(img)}

                className={'p-0 border-none bg-transparent w-40 h-24 sm:w-full sm:h-24 cursor-pointer'}>
                <img
                  src={img}
                  alt={`thumbnail-${index}`}
                  className={'w-full h-full object-cover lg:border border-primary-700 rounded-lg'}
                />
              </Button>
            ))}
        </div>

        <div className={'lg:w-[45vw] w-full h-64 sm:h-80 lg:h-[80vh] xl:h-[60vh] 2xl:h-[45vh] flex items-center justify-center rounded-xl'}>
          {bigImage && (
            <img
              src={bigImage}
              alt={'big preview'}
              className={'w-full h-full object-fit rounded-xl'}
            />
          )}
        </div>

        <div ref={thumbnailRef}>
          <div className={'w-[90vw] lg:hidden block flex gap-4 overflow-x-auto px-2 py-2 sm:h-40 whitespace-nowrap'}>
            {Array.isArray(data.imageUrl) &&
           data.imageUrl.map((img, index) => (
             <Button
               key={index}
               onClick={() => handleImageClick(img)}
               className={'bg-secondary-300 p-0 border-none h-20 w-20 flex-shrink-0 cursor-pointer'}
             >
               <img
                 src={img}
                 alt={`thumbnail-${index}`}
                 className={'w-full h-full object-cover border border-primary-700 rounded-lg'}
               />
             </Button>
           ))}
          </div>
        </div>
      </div>
    </div>
  );
};

ImageSection.propTypes = {
  data: PropTypes.shape({
    imageUrl: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
    ]),
    productName: PropTypes.string,
  }),
};

export default ImageSection;
